import React from 'react';
const PipeLongVerticalIcon = ({ width = 64, height = 64 }) => {
  const id = React.useId().replace(/:/g, '');
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 7.43 112.5">
      <defs>
        <linearGradient id={`${id}_1`} gradientUnits="userSpaceOnUse" x1="2.441406e-004" y1="56.25" x2="7.4299" y2="56.25">
          <stop offset="0.01" stopColor="#646464" />
          <stop offset="0.18" stopColor="#949494" />
          <stop offset="0.5" stopColor="#DFDFDF" />
          <stop offset="1" stopColor="#656565" />
        </linearGradient>
      </defs>
      <path fill={`url(#${id}_1)`} d="M7.43,0.016v112.469H0V0.016H7.43z" />
    </svg>
  );
};
export default PipeLongVerticalIcon;
